import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://backend.ems.uk.hiradentallab.com/api', // ✅ Your backend base URL
    headers: {
        'Content-Type': 'application/json',
    },
});

// Signin.jsx saves the token as "token" (and "accessToken" for older code)
const getToken = () => localStorage.getItem('token') || localStorage.getItem('accessToken');

// Only send the token to our own backend, never to third-party sites (e.g. restcountries.com)
const isOurBackend = (config) => {
    const url = config.url || '';
    const fullUrl = url.startsWith('http') ? url : `${config.baseURL || ''}${url}`;
    return !fullUrl.startsWith('http') || fullUrl.includes('backend.ems');
};

// 🔑 Attach the login token to every request
//    (THIS WAS MISSING – without it every protected route returned 401)
const attachToken = (config) => {
    if (!isOurBackend(config)) return config;

    const token = getToken();
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
};

// 🛡️ Auto-logout on 401
const handleUnauthorized = (error) => {
    if (error.response?.status === 401 && isOurBackend(error.config || {})) {
        localStorage.clear();
        alert('Session expired or unauthorized access. Please login again.');
        window.location.href = '/signin';
    }
    return Promise.reject(error);
};

// 1) Pages that import this instance
instance.interceptors.request.use(attachToken, (error) => Promise.reject(error));
instance.interceptors.response.use((response) => response, handleUnauthorized);

// 2) Pages that still use plain `import axios from "axios"` (all-emps, emps-schedule, ...)
//    axios.create() instances don't share interceptors, so register on the default axios too.
//    Only the token is added here – no auto-logout, so old pages behave as before.
if (!window.__emsAxiosTokenInterceptor) {
    axios.interceptors.request.use(attachToken, (error) => Promise.reject(error));
    window.__emsAxiosTokenInterceptor = true;
}

// 3) Pages that use the browser's native fetch() (all-emps, current-month-atd, ...)
//    fetch() doesn't go through axios at all, so we wrap it once here
//    and add the token to requests that go to our backend.
if (!window.__emsFetchTokenPatched) {
    const originalFetch = window.fetch.bind(window);

    window.fetch = (input, init = {}) => {
        const url = typeof input === 'string' ? input : (input?.url || '');
        const token = getToken();

        if (token && url.includes('backend.ems')) {
            const headers = new Headers(
                init.headers || (input instanceof Request ? input.headers : undefined)
            );
            if (!headers.has('Authorization')) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            init = { ...init, headers };
        }

        return originalFetch(input, init);
    };

    window.__emsFetchTokenPatched = true;
}

export default instance;